import { ArtifactSurface } from '@components/layout/artifact';
import { useShellStore } from '@store/shell';
import Styled from './ArtifactPanel.styled';

function ArtifactPanel() {
  const isOpen = useShellStore((store) => store.artifactSurface === 'panel');
  const setArtifactSurface = useShellStore((store) => store.setArtifactSurface);

  return (
    <Styled.Wrapper data-testid="artifact-panel" isOpen={isOpen}>
      <ArtifactSurface
        isEnabled={isOpen}
        onClose={() => setArtifactSurface('none')}
      />
    </Styled.Wrapper>
  );
}

export default ArtifactPanel;
